var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', [_vm._v("\n  " + _vm._s(_vm.formValue[_vm.config.prop]) + "\n  "), _c('el-button', { attrs: { "type": "primary" }, on: { "click": _vm.handleClick } }, [_vm._v("\n    快速配置\n  ")]), _vm._v(" "), _c('dialog-form', { attrs: { "dialog-config": _vm.dialog.config, "form-value": _vm.dialog.value, "form-item-list": _vm.dialog.itemList }, on: { "submit": _vm.autoFill } })], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };